import { createFileRoute } from '@tanstack/react-router'
import { CustomerSharePage } from '@/features/quote-builder/publishing/share-page'

export const Route = createFileRoute('/_authenticated/quotes/$quoteId/share')({
  staticData: { title: 'Share Quote' },
  component: ShareRoute,
})

function ShareRoute() {
  const { quoteId } = Route.useParams()
  return <CustomerSharePage quoteId={quoteId} />
}
